import React from 'react'
import styles from './InstaControllerFooter.module.scss'
import { Button } from 'antd'
import { useComponentLocale } from '../../hooks/useComponentLocale'

function InstaControllerFooter({ rawHandResponse, rawHandRequest, onSendHand, onResetHand }) {
	const getLocale = useComponentLocale()
	const analyzeHandLocale = getLocale({ component: 'instahand', section: 'analyze_hand' })
	const backLocale = getLocale({ component: 'common_buttons', section: 'back' })

	const isShowAnalyzeBtn = !rawHandResponse
	const isShowBackBtn = !isShowAnalyzeBtn

	return (
		<div className={styles.instaControllerFooterContainer}>
			{isShowAnalyzeBtn && (
				<Button onClick={onSendHand} disabled={rawHandResponse || rawHandRequest} loading={rawHandRequest}>
					{analyzeHandLocale}
				</Button>
			)}

			{isShowBackBtn && (
				<Button onClick={onResetHand} style={{ marginRight: 8 }}>
					{backLocale}
				</Button>
			)}
		</div>
	)
}

export default React.memo(InstaControllerFooter)
